import { render } from "./ManageRegions.vue?vue&type=template&id=5bef441c&scoped=true"
import script from "./ManageRegions.vue?vue&type=script&lang=js"
export * from "./ManageRegions.vue?vue&type=script&lang=js"

import "./ManageRegions.vue?vue&type=style&index=0&id=5bef441c&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5bef441c"]])

export default __exports__